import LoadableWithLoading from '@ncigdc/components/LoadableWithLoading';

const GenesBarChart = LoadableWithLoading({
  loader: () => import('./GenesBarChart'),
});
export default GenesBarChart;



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/GenesBarChart/index.js